import React, { Component } from 'react';
import { Pie } from 'react-chartjs-2';
import axios from 'axios';
import Spinner from '../Common/Spinner';

class MembershipDashboard extends Component {

    constructor() {
        super();
        this.state = {
            membershipData: []
            , memberships: []
            , membershipSales: []
            , membershipSalesData: []
            , stores: []
            , storeList: []
            , rightHeight: 40
            , searchStore: ""
            , storeID: ''
            , loading: false
        };

        this.loadMembershipDashboard = this.loadMembershipDashboard.bind(this);
        this.onStoreChange = this.onStoreChange.bind(this);
        this.onSearchClick = this.onSearchClick.bind(this);
        this.onClearSearch = this.onClearSearch.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    };

    async componentDidMount() {
        this.setState({ storeID: this.props.user.store.key });
        let storeList = [];
        storeList.push(this.props.user.store.key);

        await this.props.getUserStores(this.props.user.user.RegistrationID, "").then((stores) => {
            if (stores.length > 1) {
                stores.unshift({ key: '', StoreCode: 'All', StoreName: 'Stores' })
            }
            this.setState({ stores: stores })
        });

        this.setState({ storeList: storeList, storeID: this.props.user.store.key });
        this.loadMembershipDashboard(storeList);
    };

    componentWillMount() {
        document.body.className = "skin-green fixed sidebar-mini sidebar-mini-expand-feature sidebar-collapse";
    };

    handleKeyPress(e) {
        if (e.key === 'Enter') {
            this.onSearchClick()
        }
    };

    async loadMembershipDashboard(storeList) {
        this.setState({ loading: true });
        
        try {
            
            
            // Call the unified API endpoint
            const response = await this.props.getMembershipDashboard(storeList);
            
            if (response.data.code === "0") {
                this.setState({
                    memberships: response.data.memberships,
                    membershipData: response.data.membershipData,
                    membershipSalesData: response.data.membershipSalesData,
                    membershipSales: response.data.membershipSales,
                    sum_total_count: response.data.sum_total_count,
                    sum_total_expired: response.data.sum_total_expired,
                    sum_total_active: response.data.sum_total_active,
                    sum_total_sales: response.data.sum_total_sales,
                    sum_total_transactions: response.data.sum_total_transactions,
                    loading: false
                });
            } else {
                console.error('API Error:', response.data);
                this.setState({ loading: false });
            }
        } catch (error) {
            console.error('Error loading membership dashboard:', error);
            this.setState({ loading: false });
        }
    };

    onSearchClick() {
        this.loadMembershipDashboard(this.state.storeList);
    };

    onClearSearch() {
        let storeList = [];
        storeList.push(this.props.user.store.key);

        this.setState({
            storeList: storeList
        });
        this.loadMembershipDashboard(storeList);
    };

    onStoreChange(e) {
        let storeList = []
        if (e.target.value !== "") {
            storeList.push(e.target.value)
        }
        else {
            for (let i = 0; i < this.state.stores.length; i++) {
                const store = this.state.stores[i];
                if (store.key !== '') {
                    storeList.push(store.key)
                }
            }
        }
        this.setState({ storeList: storeList, storeID: e.target.value })
    }

    render() {
        if (this.state.loading) {
            return <Spinner/>
        }

        return <div className="content-wrapper" style={{ overflowX: "hidden" }}>
            <section className="content" style={{ overflowX: "hidden" }}>
                <div className="row">
                    <div className="col-xs-12 hidden-md hidden-lg hiddn-xl hidden-sm">
                        <font style={{ fontSize: "30px", marginBottom: "4px" }}>Membership Dashboard</font>
                    </div>
                    <div className="col-xs-12 hidden-md hidden-lg hiddn-xl hidden-sm">
                        <select type="select" className="form-control"
                            value={this.state.storeID}
                            onChange={this.onStoreChange}>
                            {this.state.stores.filter((e) => !e.IsDeleted).map((store) =>
                                <option key={store.key} value={store.key}>{store.StoreCode}-{store.StoreName}</option>
                            )}
                        </select>
                    </div>

                    <div className="col-xs-2 hidden-md hidden-lg hiddn-xl hidden-sm" style={{ paddingLeft: "0px" }}>
                        <button type="button" className="btn btn-primary btn-flat btn-md fa fa-search"
                            style={{ width: "100%", height: "34px" }}
                            onClick={this.onSearchClick}></button>
                    </div>
                    <div className="col-md-12 hidden-xs">
                        <div className="row">
                            <div className="col-md-4">
                                <font style={{ fontSize: "30px", marginBottom: "4px" }}>Membership Dashboard</font>
                            </div>
                            <div className="col-md-8">
                                <div className="input-group pull-right">
                                    <select type="select" className="form-control" value={this.state.storeID} style={{ width: "86%" }}
                                        onChange={this.onStoreChange}>
                                        {this.state.stores.filter((e) => !e.IsDeleted).map((store) =>
                                            <option key={store.key} value={store.key}>{store.StoreCode}-{store.StoreName}</option>
                                        )}
                                    </select>
                                    <button type="button" className="btn btn-primary btn-flat btn-md fa fa-search" style={{ padding: "8px" }}
                                        onClick={this.onSearchClick}></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="box-body">
                        <div className="row">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="box">
                                    <div className="box-header with-border" style={{ paddingLeft: "10px" }}>
                                        <h3 className="box-title">Memberships</h3>
                                    </div>
                                    <div className="box-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div
                                                    className="table-responsive scroll2"
                                                    style={{
                                                        height: this.state.rightHeight + "vh",
                                                        overflowY: "auto",
                                                        overflowX: "auto",
                                                        width: "100%"
                                                    }}>
                                                    {this.state.membershipData.length > 0 && <table className="table no-margin">
                                                        <thead>
                                                            <tr>
                                                                <th>Membership</th>
                                                                <th style={{ textAlign: "right" }}>Expired</th>
                                                                <th style={{ textAlign: "right" }}>Active</th>
                                                                <th style={{ textAlign: "right" }}>Total Count</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.membershipData.map((membership, index) =>
                                                                <tr key={index}>
                                                                    <td>{membership.name}</td>
                                                                    <td style={{ textAlign: "right" }}>{membership.expired_count || 0}</td>
                                                                    <td style={{ textAlign: "right" }}>{membership.active_count || 0}</td>
                                                                    <td style={{ textAlign: "right" }}>{membership.total_count}</td>
                                                                </tr>
                                                            )}
                                                            <tr>
                                                                <td><b>Totals</b></td>
                                                                <td style={{ textAlign: "right" }}><b>{this.state.sum_total_expired || 0}</b></td>
                                                                <td style={{ textAlign: "right" }}><b>{this.state.sum_total_active || 0}</b></td>
                                                                <td style={{ textAlign: "right" }}><b>{this.state.sum_total_count || 0}</b></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>}
                                                    {this.state.membershipData.length === 0 && "No records found"}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div
                                                    className="chart"
                                                    style={{
                                                        height: this.state.rightHeight + "vh",
                                                        width: "100%",
                                                        overflow: "hidden"
                                                    }}>
                                                    {this.state.memberships.labels && this.state.memberships.labels.length > 0 &&
                                                        <Pie
                                                            width={150}
                                                            height={70}
                                                            data={this.state.memberships}
                                                            options={{
                                                                maintainAspectRatio: false
                                                            }}
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 col-sm-12 col-xs-12">
                                <div className="box">
                                    <div className="box-header with-border" style={{ paddingLeft: "10px" }}>
                                        <h3 className="box-title">Membership Sales</h3>
                                    </div>
                                    <div className="box-body">
                                        <div className="row">
                                            <div className="col-md-6">
                                                <div
                                                    className="table-responsive scroll2"
                                                    style={{
                                                        height: this.state.rightHeight + "vh",
                                                        overflowY: "auto",
                                                        overflowX: "auto",
                                                        width: "100%"
                                                    }}>
                                                    {this.state.membershipSalesData.length > 0 && <table className="table no-margin">
                                                        <thead>
                                                            <tr>
                                                                <th>Membership</th>
                                                                <th style={{ textAlign: "right" }}>Total Transactions</th>
                                                                <th style={{ textAlign: "right" }}>Total Sales</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {this.state.membershipSalesData.map((membership, index) =>
                                                                <tr key={index}>
                                                                    <td>{membership.name}</td>
                                                                    <td style={{ textAlign: "right" }}>{membership.total_transactions}</td>
                                                                    <td style={{ textAlign: "right" }}>{membership.total_sales}</td>
                                                                </tr>
                                                            )}
                                                            <tr>
                                                                <td><b>Totals</b></td>
                                                                <td style={{ textAlign: "right" }}><b>{this.state.sum_total_transactions || 0}</b></td>
                                                                <td style={{ textAlign: "right" }}><b>{this.state.sum_total_sales || 0}</b></td>
                                                            </tr>
                                                        </tbody>
                                                    </table>}
                                                    {this.state.membershipSalesData.length === 0 && "No records found"}
                                                </div>
                                            </div>
                                            <div className="col-md-6">
                                                <div
                                                    className="chart"
                                                    style={{
                                                        height: this.state.rightHeight + "vh",
                                                        width: "100%",
                                                        overflow: "hidden"
                                                    }}>
                                                    {this.state.membershipSales.labels && this.state.membershipSales.labels.length > 0 &&
                                                        <Pie
                                                            width={150}
                                                            height={70}
                                                            data={this.state.membershipSales}
                                                            options={{
                                                                maintainAspectRatio: false
                                                            }}
                                                        />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    };
};

export default MembershipDashboard;